import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@tencent/spaui';
import { enumMessages } from '@/utils/MessageUtils';
import { hasFeatureFlag, hasFeatureFlagSuper, hasPurview } from '@/services';

class AdPlatformTypeSelect extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
  }

  render() {
    const { value, onChange, onClear, disabled } = this.props;

    let data = _.map(enumMessages('RegistrationAdPlatformType'), (message) => {
      return {
        value: message.value,
        label: message.message,
      };
    });

    // 只开放腾讯广告
    data = (_.compact(data) || []).filter((item) => item.label === '腾讯广告');
    return <Select disabled={true} clear={true} className="AdPlatformSelect" data={data} value={value} onChange={onChange} />;
  }
}
export default AdPlatformTypeSelect;
